import React, { useState } from "react";
import { Card, Row, Col, Button } from "antd";
import Image from "next/image";
import { useIntl } from "react-intl";
import CurrencySymbol from "@/Components/Common/CurrencySymbol/CurrencySymbol";
import { IFavouriteDepartures } from "../../Orchestrator/Types/Interface/IFavouriteDepartures";
import { formatDayAndMonthByLocale } from "../../Lib/Utils/validationUtil";
import { _eventBus } from "../../core/events/EventBus";
import { trainOfferEvtTree } from "../../Orchestrator/ConstantTree";
import { SearchStateType } from "../../Orchestrator/Types/Index";
import { getSearchSelectedPassenger } from "../../Lib/Utils/passenger";
import { updateRecoilState } from "../../Orchestrator/Recoils/Events/Recoil";

const FavouriteDeparture = ({ data }: any) => {
    const intl = useIntl();
    const handleBookNow = (trip: IFavouriteDepartures) => {
        const passengersObject: { [key: string]: number } = { adults: 1 };
        const searchStateObject: SearchStateType = {
            fromName: trip.from,
            toName: trip.to,
            from: trip.fromCode,
            to: trip.toCode,
            calc: "",
            passengers: passengersObject
        };
        const { totalPassengerCount, passengerCounts } = getSearchSelectedPassenger(
            searchStateObject.passengers
        );
        updateRecoilState("searchStateAtom", searchStateObject);
        updateRecoilState("isAnonymousStateAtom", false);
        updateRecoilState("selectedOfferIdAtom", trip.offerId);
        updateRecoilState("trainTypeAtom", "outbound");
        updateRecoilState("offersRequestAtom", trip.offersRequest);
        updateRecoilState("selectedOutboundTrainAtom", trip.train);
        _eventBus.emit({
            eventName: trainOfferEvtTree.Offer.ContinueBtn.Click,
            data: {
                search: searchStateObject,
                offerId: trip.offerId,
                isAnonymous: false,
                totalPassengerCount: totalPassengerCount,
                passengerCounts: passengerCounts,
                currentTrainType: "outbound",
                outboundOfferId: null,
                offersRequest: trip.offersRequest,
                selectedOutboundTrain: trip.train,
                shuttleOfferId: null,
                outboundShuttleOfferId: null,
                booking: null,
                selectedChangeDateAtom: "",
                inboundSelectedChangeDateAtom: "",
                selectedPassengerForCancel: [],
                selectedPassengerForCancelInBound: [],
                isChangeDate: false,
                SelectedOfferIdChangeDateAtom: "",
                searchStates: searchStateObject,
                selectedTrain: null,
                fmlmFilter: null,
                isBookReturnJourney: false
            },
        });
    }
    const isBookable = (trip: IFavouriteDepartures) => Boolean(trip.offerId && trip.train);
    return (
        <>
            <div>
                {data.length > 0 && (
                    <Row className="favourite_box" gutter={[0, 0]}>
                        <Col span={12}>
                            <div className="location_image">
                                {data[0].imgSrc && (
                                    <img src={data[0].imgSrc} alt={`${data[0].from} to ${data[0].to}`} />
                                )}
                                <div className="location_text">
                                    <div>
                                        {data[0].from} {" "}
                                        <Image
                                            src="/assets/search_icons/arrow-right.svg"
                                            width={20}
                                            height={20}
                                            alt="arrow"
                                            className="ml-10 mr-10 right-arrow" />{" "}
                                        {data[0].to}
                                    </div>
                                    {(data[0].departureTime || data[0].arrivalTime) && (
                                        <div>{data[0].departureTime} - {data[0].arrivalTime}</div>
                                    )}
                                </div>
                            </div>
                        </Col>

                        <Col span={12} className="fav_content">
                            {data.map((trip: IFavouriteDepartures, index: number) => (
                                <Card key={index}>

                                    <div className="card_inner">
                                        <div className="card_left">
                                            <span className="dep_date">{formatDayAndMonthByLocale(trip.departureDate)}</span>
                                            <div className="dep_value">
                                                {trip.classType == "standardValue" && (
                                                    <>
                                                        <span className="value_title">
                                                            {intl.formatMessage({ id: "standardValue" })}
                                                        </span>
                                                        <span className="sep">&bull;</span>
                                                    </>
                                                )}
                                                {trip.classType == "standardPro" && (
                                                    <>
                                                        <span className="value_title">
                                                            {intl.formatMessage({ id: "standardPro" })}
                                                        </span>
                                                        <span className="sep">&bull;</span>
                                                    </>
                                                )}
                                                {trip.classType == "premium" && (
                                                    <>
                                                        <span className="value_title">
                                                            {intl.formatMessage({ id: "premium" })}
                                                        </span>
                                                        <span className="sep">&bull;</span>
                                                    </>
                                                )}
                                                <span className="book_price"><bdi dir={intl.locale === 'ar' ? 'rtl' : 'ltr'}>{trip.price} <CurrencySymbol /></bdi></span>
                                            </div>
                                        </div>
                                        {isBookable(trip) && (
                                            <div className="card_button">
                                                <Button
                                                    type="primary"
                                                    shape="round"
                                                    className="custom_space fw-600 fs-16"
                                                    onClick={() => handleBookNow(trip)}
                                                >
                                                    {intl.formatMessage({ id: "book" })}
                                                    <Image
                                                        src={"/assets/booking/right_small_arrow.svg"}
                                                        alt="book"
                                                        width={14}
                                                        height={10} />
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            ))}
                        </Col>
                    </Row>
                )}
            </div>
        </>
    );
};

export default FavouriteDeparture;
